"use client";
import React, { useState } from "react";
import styled from "styled-components";
import { Container, Row, Col, Modal } from "react-bootstrap";
import Link from "next/link";
import { Img } from "../Img";
import { Transition } from "@/styles/globalStyleVars";
import Title from "../Title";
import Button from "../Button";
import HtmlParser from "react-html-parser";
export default function Video({ data }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };


  return (
    <StyledComponent className="video pt-200 pb-200">
      <Container>
        <Row>
          <Col lg={6}>
            <div className="video-modal__img " onClick={handleShow}>
              <Img src={data?.[0]?.detail?.video_thumb} alt={'Video Image'}/>
              <div className="video-modal__img__click">
                <svg width="32" height="40" viewBox="0 0 32 40">
                  <path
                    id="Polygon_1"
                    data-name="Polygon 1"
                    d="M20,0,40,32H0Z"
                    transform="translate(32) rotate(90)"
                    fill="#fff"
                  />
                </svg>
                <span className="circle" />
                <span className="blur" />
              </div>
            </div>
          </Col>

          <Col lg={{ span: 5, offset: 1 }}>
            <h2>{data?.[0]?.detail?.title}</h2>
            <p>{HtmlParser(data?.[0]?.detail?.desc)}</p>
	          <Button
		          margin={"30px 0 0 0"}
		          target={"_blank"}
		          text={data?.[0]?.detail?.btn_text}
		          src={data?.[0]?.detail?.btn_url}
	          />
          </Col>
        </Row>
      </Container>

      {/*modal*/}
      <Modal className={"modal-video"} show={show} onHide={handleClose}>
        <svg
          onClick={handleClose}
          className={"close-modal"}
          xmlns="http://www.w3.org/2000/svg"
          width="13.426"
          height="13.423"
          viewBox="0 0 13.426 13.423"
        >
          <path
            id="Icon_ionic-ios-close"
            data-name="Icon ionic-ios-close"
            d="M19.589,18l4.8-4.8A1.124,1.124,0,0,0,22.8,11.616l-4.8,4.8-4.8-4.8A1.124,1.124,0,1,0,11.616,13.2l4.8,4.8-4.8,4.8A1.124,1.124,0,0,0,13.2,24.384l4.8-4.8,4.8,4.8A1.124,1.124,0,1,0,24.384,22.8Z"
            transform="translate(-11.285 -11.289)"
            fill="#fff"
          />
        </svg>

        <Modal.Body>
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${data?.[0]?.detail?.video_id}?si=H1t21Ym3px2yQicH;controls=0&autoplay=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </Modal.Body>
      </Modal>
    </StyledComponent>
  );
}
const StyledComponent = styled.section`
  background-color: #f4f4f4;
  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  p {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
  }
  .video-modal__img {
    padding-top: calc(332 / 600 * 100%);
    position: relative;
    cursor: pointer;
    z-index: 2;

    &__click {
      position: absolute;
      inset: 0;
      margin: auto;
      width: 200px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        position: relative;
        z-index: 2;
      }

      .circle {
        border: 1px solid #fff;
        height: 100%;
        width: 100%;
        display: block;
        position: absolute;
        border-radius: 50%;
        transition: 1s ${Transition};
      }

      .blur {
        height: 150px;
        width: 150px;
        position: absolute;
        backdrop-filter: blur(5px);
        border-radius: 50%;
        /* transition: 0.6s ${ease}; */
        background-color: #ffffff24;
        opacity: 0;
        transform: scale(0.1);
        transition: 1s ${Transition};
      }
    }

    &:hover {
      .circle {
        transform: scale(0.1);
      }

      .blur {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  @media (max-width: 991px) {
    padding-top: 150px !important;
    .col-lg-6 {
      margin-bottom: 50px;
    }
    .video-modal__img__click {
      width: 100px;
      height: 100px;
      .blur {
        height: 70px;
        width: 70px;
      }
      svg {
        height: 25px;
      }
    }
  }
`;
